import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Collapse from "@material-ui/core/Collapse";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Elements, StripeProvider } from "react-stripe-elements";
import { bindActionCreators } from "redux";
import { userDetail } from "../../../config/userDetails";
import { getSubscriptionPlan } from "../../../modules/subscription/action";
import Loader from "../../Loader";
import UpgradePlanPayment from "./UpgradePlanPayment";
import { config } from "../../../config/appConfig";








const styles = {
  card: {
    minWidth: 275,
    border: "2px solid #005458",
    borderRadius: "0 90px"
  },
  cardContent1: {
    height: 150
  },
  cardContent2: {
    height: "auto"
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  },
  col: {
    backgroundColor: "#00bc84",
    color: "#fff"
  },
  expand: {
    transform: "rotate(0deg)",
    float: "right"
  },
  expandOpen: {
    transform: "rotate(180deg)",
    float: "right"
  }
};

const planDetails = {
  capabilities: [
    ,
    "Limited Risk Management and Reconciliation Capabilities",
    "Full Risk Management and Reconciliation Services",
    "Full Risk Management and Reconciliation Services",
    "Full Risk Management and Reconciliation Services"
  ],
  support: [
    ,
    "Limited Support",
    "Support Service (online and phone)",
    "Support Service (online and phone)",
    "Onsite Training and Support Service (Online and Phone)"
  ],
  print: [
    ,
    "Mobile Print add on",
    "Mobile Print add on",
    "Mobile Print add on",
    "Mobile Print add on"
  ]
};
class ChangeBillingPlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      expanded: [false, false, false],
      currentSubscriptionPlan: {},
      newPlan: {},
      openPaymentDialog: false
    };
  }
  componentWillMount() {
    this.props.actions.getSubscriptionPlan();
  }
  componentDidMount() {
    const { subscriptionList = [] } = this.props;
    let currentPlan =
      subscriptionList[
        Object.keys(subscriptionList).filter(data => {
          return subscriptionList[data].id === userDetail().planId;
        })[0]
      ];
    console.log(currentPlan);
    this.setState({ currentSubscriptionPlan: currentPlan });
  }

  getCurrentPlan = () => {
    const { subscriptionList = [] } = this.props;
    let currentPlan =
      subscriptionList[
        Object.keys(subscriptionList).filter(data => {
          return subscriptionList[data].id === userDetail().planId;
        })[0]
      ];
    return currentPlan;
  };
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.subscriptionList &&
      this.props.subscriptionList !== nextProps.subscriptionList &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    }
  }
  handlePlanChange = plan => {
    console.log(plan);
    this.setState({ openPaymentDialog: true, newPlan: plan });
  };
  handleExpandClick = index => {
    console.log(index);
    let newExpanded = this.state.expanded;
    newExpanded[index] = !this.state.expanded[index];
    this.setState({ expanded: newExpanded });
  };
  createPlanCard = (data, index, subscriptionList, classes) => (
    <Card>
      <CardHeader title={subscriptionList[data].name} />
      <CardContent style={styles.cardContent1}>
        <Grid container spacing={4}>
          <Grid item xs={6} key={`originalPrice${index}`}>
            <p className="subscripCharge">
              <Typography className={classes.pos} color="textSecondary">
                Original Price
              </Typography>
              <span className="currency">
                {subscriptionList[data].currency}
              </span>
              {subscriptionList[data].fees}
              <Typography className={classes.pos} color="textSecondary">
                Annually
              </Typography>
            </p>
          </Grid>
          <Grid item xs={6} key={`applicablePrice${index}`}>
            <p className="subscripCharge">
              <Typography className={classes.pos} color="textSecondary">
                Applicable Price
              </Typography>
              <span className="currency">
                {subscriptionList[data].currency}
              </span>
              {subscriptionList[data].fees - this.getCurrentPlan().fees}
              <Typography className={classes.pos} color="textSecondary">
                Annually
              </Typography>
            </p>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions style={{ justifyContent: "space-between" }}>
        <Button
          color="primary"
          onClick={() => this.handlePlanChange(subscriptionList[data])}
        >
          Select Plan
        </Button>
        <IconButton
          style={this.state.expanded[index] ? styles.expanded : styles.expand}
          onClick={() => this.handleExpandClick(index)}
          aria-expanded={this.state.expanded[index]}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={this.state.expanded[index]} timeout="auto" unmountOnExit>
        <CardContent style={styles.cardContent2}>
          <p className="planList">
            {`${
              subscriptionList[data].noOfContracts !== -1
                ? `Up to ${subscriptionList[data].noOfContracts}`
                : "Unlimited"
            } Contracts`}
          </p>

          <p className="planList">
            {`${
              subscriptionList[data].noOfTickets !== -1
                ? `Up to ${subscriptionList[data].noOfTickets}`
                : "Unlimited"
            } Tickets`}
          </p>
          <p className="planList">
            {`${subscriptionList[data].noOfLogins} Logins`}
          </p>

          <p className="planList">
            {subscriptionList[data].name === "Basic" ? "Limited" : ""} Print and
            Export Capabilities
          </p>
          <p className="planList">
            {planDetails.capabilities[subscriptionList[data].id]}
          </p>
          <p className="planList">
            {planDetails.support[subscriptionList[data].id]}
          </p>
          <p className="planList">
            {planDetails.print[subscriptionList[data].id]}
          </p>
          <p className="planList">{subscriptionList[data].description}</p>
        </CardContent>
      </Collapse>
    </Card>
  );

  handleClose = () => {
    this.setState({ openPaymentDialog: false });
  };

  render() {
    const { subscriptionList = [], classes } = this.props;

    return (
      <div className="innermainform">
        {/* <div className="textRequired">
            {this.state.fetchingComplete ? Object.keys(subscriptionList).filter((data)=>{
                return subscriptionList[data].id === userDetail().planId
            }).map((data)=>{
                return `Your current plan is ${subscriptionList[data].name} Plan`
            }):null}
        </div> */}
        {this.state.openPaymentDialog && (
          <StripeProvider apiKey={config.paymentkey}>
            <Elements>
              <UpgradePlanPayment
                amount={
                  this.state.newPlan &&
                  this.state.newPlan.fees - this.getCurrentPlan().fees
                }
                currency={this.state.newPlan && this.state.newPlan.currency}
                planId={this.state.newPlan.id}
                newPlanName={this.state.newPlan.name}
                currentPlanId={this.getCurrentPlan().id}
                handleClose={this.handleClose}
              />
            </Elements>
          </StripeProvider>
        )}
        <p className="loginHeader">Upgrade Plan</p>

        <Grid container spacing={24}>
          {this.state.fetchingComplete && (
            <Grid item sm={12} xs={12} key={"subscribed"}>
              {`Your current plan is ${this.getCurrentPlan().name} Plan`}
            </Grid>
          )}

          {this.state.fetchingComplete ? (
            Object.keys(subscriptionList)
              .filter(data => {
                return subscriptionList[data].id > userDetail().planId;
              })
              .map((data, index) => (
                <Grid item sm={4} xs={12} key={index}>
                  {this.createPlanCard(data, index, subscriptionList, classes)}
                </Grid>
              ))
          ) : (
            <Grid container spacing={3}>
              <Grid item sm={12} xs={12}>
                <Loader />
              </Grid>
            </Grid>
          )}
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    subscriptionList: state.subscriptionList.subscriptionListDetails
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        getSubscriptionPlan
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ChangeBillingPlan));



// WEBPACK FOOTER //
// ./src/components/private/Billing/ChangeBillingPlan.js